import { t } from '@lingui/macro'
import { SearchInput } from 'components/SearchModal/styleds'
import useDebounce from 'hooks/useDebounce'
import { useAtomValue, useUpdateAtom } from 'jotai/utils'
import { useEffect, useState } from 'react'

import { filterStringAtom } from './state'

export default function SearchBar() {
  const currentString = useAtomValue(filterStringAtom)

  const [searchQuery, setSearchQuery] = useState(currentString)
  const setFilterString = useUpdateAtom(filterStringAtom)

  const debouncedLocalFilterString = useDebounce(searchQuery, 300)

  useEffect(() => {
    setSearchQuery(currentString)
  }, [currentString])

  useEffect(() => {
    setFilterString(debouncedLocalFilterString)
  }, [debouncedLocalFilterString, setFilterString])
  return (
    <SearchInput
      width="min(500px, 100%)"
      data-cy="vote-search-input"
      type="search"
      placeholder={t`Search`}
      id="search-vote"
      autoComplete="off"
      value={searchQuery}
      onChange={({ target: { value } }) => setSearchQuery(value)}
    />
  )
}
